__turbopack_context__.v({
  "autoApprove": "DashboardPage-module-scss-module__qmZWYG__autoApprove",
  "blocksBackgroundColor": "DashboardPage-module-scss-module__qmZWYG__blocksBackgroundColor",
  "blocksFontColor": "DashboardPage-module-scss-module__qmZWYG__blocksFontColor",
  "description": "DashboardPage-module-scss-module__qmZWYG__description",
  "draftContainer": "DashboardPage-module-scss-module__qmZWYG__draftContainer",
  "footerLink": "DashboardPage-module-scss-module__qmZWYG__footerLink",
  "itemApprovalsContainer": "DashboardPage-module-scss-module__qmZWYG__itemApprovalsContainer",
  "loading": "DashboardPage-module-scss-module__qmZWYG__loading",
  "requestConfirm": "DashboardPage-module-scss-module__qmZWYG__requestConfirm",
  "requestTable": "DashboardPage-module-scss-module__qmZWYG__requestTable",
  "reviewButton": "DashboardPage-module-scss-module__qmZWYG__reviewButton",
  "secondaryNavBackgroundColor": "DashboardPage-module-scss-module__qmZWYG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "DashboardPage-module-scss-module__qmZWYG__themeBackgroundColor",
  "themeFontColor": "DashboardPage-module-scss-module__qmZWYG__themeFontColor",
  "title": "DashboardPage-module-scss-module__qmZWYG__title",
  "tooltipVertical": "DashboardPage-module-scss-module__qmZWYG__tooltipVertical",
  "transitionExit": "DashboardPage-module-scss-module__qmZWYG__transitionExit",
  "transitionExitActive": "DashboardPage-module-scss-module__qmZWYG__transitionExitActive",
  "viewMoreButton": "DashboardPage-module-scss-module__qmZWYG__viewMoreButton",
  "widget": "DashboardPage-module-scss-module__qmZWYG__widget",
});
